import {
  SmallBagIcon,
  PriorityBoardingIcon,
  CheckinBagIcon,
} from '@edreamsodigeo/prisma-design-system';
import { CabinBagsEnum } from 'enums';

export const PillTypes = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
};

export const carrierPropertiesTypeMap = {
  [CabinBagsEnum.SMALL_BAG]: 'smallBag',
  [CabinBagsEnum.CABIN_BAG]: 'cabinBag',
};

export const BOARDING_OPTIONS_SPECS = [
  'cabinBags.service1.name.mobile',
  'cabinBags.service2.name.mobile',
  'cabinBags.service3.name.mobile',
  'cabinBags.service4.name.mobile',
  'cabinBags.service3.description',
];

export const getBoardingOptions = (isHideThirdOptionEnabled = false) => [
  {
    type: CabinBagsEnum.CABIN_BAG,
    options: { 0: true, 1: true, 3: true },
    title: 'cabinBags.cabinBag.title',
    size: 'cabinBags.cabinBag.size',
    Icon: PriorityBoardingIcon,
    pill: isHideThirdOptionEnabled
      ? {
          text: 'cabinBags.warning.likely',
          variant: PillTypes.NEGATIVE,
        }
      : {
          text: 'cabinBags.most.popular',
          variant: PillTypes.POSITIVE,
        },
    isDisabled: false,
  },
  {
    type: CabinBagsEnum.SMALL_BAG,
    options: isHideThirdOptionEnabled
      ? { 0: true, 1: false, 3: false }
      : { 0: true, 1: false, 2: false, 3: false },
    title: 'cabinBags.smallBag.title',
    size: 'cabinBags.smallBag.size',
    Icon: SmallBagIcon,
    isDisabled: false,
  },
  ...(!isHideThirdOptionEnabled
    ? [
        {
          type: CabinBagsEnum.HAND_BAG,
          options: { 0: true, 4: true },
          title: 'cabinBags.handBag.title',
          size: 'cabinBags.handBag.size',
          Icon: CheckinBagIcon,
          isDisabled: true,
        },
      ]
    : []),
];

export const SMALL_BAG_AMOUNT = 0;
